import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ProblemsPage } from '../screens/admin/ProblemsPage';

const searchSchema = z.object({
  /** The problems of one company (its slug or id), as the customer page links them. */
  tenant: z.string().optional(),
  /** A search by company or job name, and the order: the ledger narrows and sorts. */
  find: z.string().optional(),
  sort: z.enum(['oldest', 'largest', 'company']).optional(),
});

export const Route = createFileRoute('/admin/problems')({
  validateSearch: searchSchema,
  component: ProblemsPage,
});
